import muiIcons from "../../../components/icons/mui-icons";

export const inboxMenuData = [
  {
    name: "Inbox (2)",
    Icon: muiIcons.EmailIcon,
  },
  {
    name: "Sent",
    Icon: muiIcons.SentIcon,
  },
  {
    name: "Starred",
    Icon: muiIcons.ChatIcon,
  },
  {
    name: "Trash",
    Icon: muiIcons.DatabaseIcon,
  },
  {
    name: "Spam",
    Icon: muiIcons.InboxIcon,
  },
];

export const messageList = [
  {
    name: "Smith Doe",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/1.jpg",
  },
  {
    name: "Jhon Doe",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "Alex",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    name: "Mathew Doe",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/1.jpg",
  },
  {
    name: "Smith Doe",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/1.jpg",
  },
  {
    name: "Jhon Doe",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "Alex",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    name: "Mathew Doe",
    date: "20 Oct 2021",
    message: "Confirm your email",
    photoUrl: "/assets/images/faces/1.jpg",
  },
];
